import Icon from '@/components/snippets/icon/icon'

export const ReceiveRewardBanner = ({ children }) => {
  return (
    <div className={'w-full rounded-md bg-secondary-paleblue bg-opacity-[0.24]'}>
      <div className={'flex flex-row items-center gap-2.5 p-2'}>
        <Icon id="gift" className={'h-4 w-4'} />
        <div>
          <p className={'paragraph-xs'}>{children}</p>
        </div>
      </div>
    </div>
  )
}
